import { RestSlice } from '../../../../../redux/rest.slice';
import { SentNoticeHistory } from '@rcp/types';
import { localizationService, Resource } from 'src/services';

export const noticeHistorySlice = new RestSlice<SentNoticeHistory>(
	localizationService.getLocalizedString('noticeHistory.histories'),
	Resource.NoticeHistories
);
export default noticeHistorySlice.rests.reducer;
